// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import StopTwoToneSvg from "@ant-design/icons-svg/es/asn/StopTwoTone";
import AntdIcon from '../components/AntdIcon';

var StopTwoTone = function StopTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: StopTwoToneSvg
  }));
};

StopTwoTone.displayName = 'StopTwoTone';
export default React.forwardRef(StopTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/StopTwoTone.js
// module id = 1883
// module chunks = 0